module.exports = __webpack_public_path__ + "img/extend_1.13f5b71c.png";